import AuthenticatedUserOutput from "@/entities/AuthenticatedUserOutput";

export default abstract class BaseAuth {
  /**
   * @description Get current authenticated user
   * @returns Promise resolves to current authenticated CognitoUser, that contains:
   * - id {string} - Cognito session user id
   * - token {string} - Cognito idToken
   */
  protected abstract getAuthenticatedUser(): Promise<AuthenticatedUserOutput>;

  async getSessionUserId() {
    return (await this.getAuthenticatedUser()).id;
  }
  async getSessionIdToken() {
    return (await this.getAuthenticatedUser()).token;
  }
}
